module.exports = __webpack_public_path__ + "img/approval.8b429b6d.svg";